import { createContext, ReactNode, useContext } from 'react'
import { connect } from 'react-redux'
import { ReduxState } from '~/redux/createRootReducer'
import { ConfigState, initState } from '~/config/configReducer'

// TODO: Move this file to src/config

type ConfigContextType = {
  config: ConfigState
}

const ConfigContext = createContext<ConfigContextType>({ config: initState })

const mapStateToProps = (state: ReduxState) => ({
  config: state.config,
})

interface ConfigProps {
  children: ReactNode
  config: ConfigState
}

export const ConfigProvider = connect(mapStateToProps)(({ config, children }: ConfigProps) => (
  <ConfigContext.Provider value={{ config }}>{children}</ConfigContext.Provider>
))

export const useConfig = () => useContext(ConfigContext)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const withConfig = (WrappedComponent: any) => {
  const WithConfig = ({ ...props }) => (
    <ConfigContext.Consumer>{({ config }) => <WrappedComponent {...props} config={config} />}</ConfigContext.Consumer>
  )

  return WithConfig
}
